module.exports = __webpack_public_path__ + "img/wallet.e657db5.png";